import React, { useState,  } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const MenuWrapper = styled.nav`
  display: flex;
  background-color: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(12px); /* Efecto cristal moderno */
  -webkit-backdrop-filter: blur(12px);
  align-items: center;
  justify-content: space-between;
  padding: 0 5%;
  height: 80px;
  position: sticky;
  top: 0;
  z-index: 1000;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`;

const Logo = styled(Link)`
  display: flex;
  align-items: center;
  img {
    height: 50px;
    transition: transform 0.3s ease;
  }
  &:hover img {
    transform: scale(1.05);
  }
`;

const MenuButton = styled.button`
  background-color: #0f172a;
  border: none;
  cursor: pointer;
  padding: 12px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;

  @media only screen and (min-width: 992px) {
    display: none;
  }
`;

const MenuIcon = styled.div`
  width: 20px;
  height: 2px;
  background-color: #fff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &.open:first-child {
    transform: rotate(45deg) translate(5px, 5px);
  }
  &.open:nth-child(2) {
    opacity: 0;
  }
  &.open:last-child {
    transform: rotate(-45deg) translate(5px, -5px);
  }
`;

const MenuItems = styled.div`
  position: fixed;
  top: 80px;
  right: 0;
  background-color: #fff;
  width: 100%; /* Ocupa todo el ancho en mobile para mejor UX */
  height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  padding: 40px;
  gap: 20px;
  transition: transform 0.4s ease-in-out;
  transform: ${({ open }) => (open ? 'translateX(0%)' : 'translateX(100%)')};

  @media only screen and (min-width: 992px) {
    position: relative;
    top: auto;
    right: auto;
    transform: none;
    width: auto;
    height: auto;
    background-color: transparent;
    padding: 0;
    flex-direction: row;
    gap: 10px;
  }
`;

const MenuItem = styled(Link)`
  color: #1e293b;
  text-decoration: none;
  font-size: 18px;
  font-weight: 500;
  padding: 10px 15px;
  position: relative;
  transition: color 0.3s ease;

  @media only screen and (min-width: 992px) {
    font-size: 15px;
    
    /* Animación de subrayado */
    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 2px;
      bottom: 0;
      left: 50%;
      background-color: #3b82f6;
      transition: all 0.3s ease;
      transform: translateX(-50%);
    }

    &:hover::after {
      width: 70%;
    }
  }

  &:hover {
    color: #3b82f6;
  }
`;

// Botón destacado para el Cotizador
const CTAButton = styled(MenuItem)`
  background-color: #0f172a;
  color: #fff !important;
  border-radius: 50px;
  padding: 10px 25px !important;
  margin-left: 10px;
  text-align: center;

  &::after { display: none; } /* Quitamos el subrayado */

  &:hover {
    background-color: #334155;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
`;

const Menu = () => {
  const [open, setOpen] = useState(false);
  const toggleMenu = () => setOpen(!open);
  const handleItemClick = () => setOpen(false);

  return (
    <MenuWrapper>
      <Logo to="/">
        <img src="./img/logi.png" alt="Logo" />
      </Logo>

      <MenuButton onClick={toggleMenu}>
        <MenuIcon className={open ? 'open' : ''} />
        <MenuIcon className={open ? 'open' : ''} />
        <MenuIcon className={open ? 'open' : ''} />
      </MenuButton>

      <MenuItems open={open}>
        <MenuItem to="/Nosotros" onClick={handleItemClick}>Nosotros</MenuItem>
        <MenuItem to="/Trabajos" onClick={handleItemClick}>Clientes</MenuItem>
        <MenuItem to="/Promo" onClick={handleItemClick}>Servicios</MenuItem>
        <MenuItem to="/contacto" onClick={handleItemClick}>Contacto</MenuItem>
        <MenuItem to="/Redes" onClick={handleItemClick}>Redes</MenuItem>
        <CTAButton to="/Cotizador" onClick={handleItemClick}>Cotizar Proyecto</CTAButton>
        <MenuItem to="/Dashboard" onClick={handleItemClick} style={{fontSize: '12px', opacity: 0.6}}>Usuarios</MenuItem>
      </MenuItems>
    </MenuWrapper>
  );
};

export default Menu;